// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1-nJE","calendarButtons":"ClockData_calendarButtons__tfThQ"};